import { Anthropic } from '@anthropic-ai/sdk'
import { AuthedAxiosRequests } from 'features/auth'
import { postFetcher } from 'features/rolodex'

export async function askClaude(
  content: Array<Anthropic.MessageParam>,
  axios: AuthedAxiosRequests,
  llm_url: string
): Promise<Anthropic.Message> {
  // Swap the URL to be a environment variable
  const URL = `${llm_url}/api/v1/claude37/generate`

  const body = {
    max_tokens: 250,
    content: content,
  }

  return postFetcher(URL, JSON.stringify(body), axios)
}
